import { VariantProps } from "@gluestack-ui/utils";
import React from "react";
import { Pressable, Text } from "react-native";
import { CloseIcon, Icon } from "../Icon/Icon";
import { chipStyle, iconStyle, labelStyle } from "./Chip.styles";

export type IChipProps = React.ComponentPropsWithoutRef<typeof Pressable> & {
	label: string;
	onClick?: () => void;
	onDelete?: () => void;
} & VariantProps<typeof chipStyle> & { className?: string };

export const Chip = React.forwardRef<React.ComponentRef<typeof Pressable>, IChipProps>(
	({ size = "sm", className, label, action = "default", onClick, onDelete, ...props }, ref) => {
		const disabled = !onDelete && !onClick;

		return (
			<Pressable
				ref={ref}
				{...props}
				onPress={onDelete ?? onClick}
				className={chipStyle({
					size,
					action,
					disabled,
					class: className,
				})}
				disabled={disabled}
			>
				<Text
					className={labelStyle({
						parentVariants: {
							action,
						},
					})}
				>
					{label}
				</Text>
				{!!onDelete && (
					<Icon
						as={CloseIcon}
						size="sm"
						className={iconStyle({
							parentVariants: {
								action,
							},
						})}
					/>
				)}
			</Pressable>
		);
	},
);
